export class PlacementSession {
    placementId: string;

    /**
     * Orbit BookingSessions.Id — the exact session this calendar slot addresses. Drives the
     * add-session-v2 navigation so a report is bound to one session, not just a date/time
     * (SessionIdentityGrain.md).
     */
    sessionId: number;

    tutorId: number;
    startDate: Date;
    startTime: any;
    endTime: any;
    breakTime: number;
    disabled: boolean;
    status: string;
    suggestedSession: boolean;

    /**
     * True when this session's date falls outside the booking's own start/end window. Set by the
     * view-sessions backend so the calendar tile can be styled as out-of-range.
     */
    outsideDateRange: boolean;

    selected: boolean;

    constructor() {
        this.selected = false;
        this.outsideDateRange = false;
    }
}